import React, { useState } from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const ContractFilters = ({
  filters,
  onFilterChange,
  onClearFilters,
  onRefresh,
  onOpenAdvancedSearch,
}) => {
  const [openSelectId, setOpenSelectId] = useState(null);

  const statusOptions = [
    { value: 'all', label: 'Todos os Status' },
    { value: 'DRAFT', label: 'Rascunho' },
    { value: 'MANUAL', label: 'Manual' },
    { value: 'PDF_GENERATED', label: 'PDF Gerado' },
    { value: 'PDF_UPLOADED', label: 'PDF enviado (upload)' },
    { value: 'PENDING_SIGNATURE', label: 'Aguardando assinatura' },
    { value: 'SIGNED', label: 'Assinado por todos' },
  ];

  const typeOptions = [
    { value: 'all', label: 'Todos os Tipos' },
    { value: 'uploaded_signature', label: 'Documentos enviados (upload)' },
    { value: 'MANUAL', label: 'Somente documentos manuais' },
    { value: 'compromisso_compra_venda', label: 'Compromisso de Compra e Venda' },
    { value: 'contrato_locacao_imovel', label: 'Contrato de Locacao de Imovel' },
    { value: 'autorizacao_locacao_imovel', label: 'Autorização para Locação de Imóvel' },
    { value: 'proposta_compra_imovel', label: 'Proposta de Compra de Imóvel' },
    { value: 'contrato_parceria_vendas', label: 'Contrato de Parceria para Vendas' },
    { value: 'recibo_simples', label: 'Recibo Simples' },
    { value: 'autorizacao_gleba_loteamento', label: 'Autorização Gleba Loteamento' },
    { value: 'autorizacao_venda_imovel', label: 'Autorização para Venda de Imóvel' },
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 mb-6 shadow-elevation-sm">
      <p className="text-xs text-muted-foreground mb-3">
        Filtros rápidos aplicam-se só aos documentos já carregados na lista. Para buscar no
        servidor, use Busca avançada.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <Input
          type="search"
          placeholder="Filtrar por nome (lista carregada)…"
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e.target.value)}
          className="w-full"
        />

        <Select
          options={statusOptions}
          value={filters?.status}
          open={openSelectId === 'status'}
          onOpenChange={(o) => setOpenSelectId(o ? 'status' : null)}
          onChange={(value) => onFilterChange('status', value)}
          placeholder="Filtrar por status"
        />

        <Select
          options={typeOptions}
          value={filters?.type}
          open={openSelectId === 'type'}
          onOpenChange={(o) => setOpenSelectId(o ? 'type' : null)}
          onChange={(value) => onFilterChange('type', value)}
          placeholder="Filtrar por tipo"
        />

        <div className="flex flex-col sm:flex-row gap-2 lg:col-span-2">
          <Button
            variant="default"
            iconName="Search"
            onClick={onOpenAdvancedSearch}
            className="flex-1 w-full sm:w-auto"
          >
            Busca avançada
          </Button>

          <Button
            variant="outline"
            iconName="RefreshCw"
            onClick={onRefresh}
            className="flex-1 w-full sm:w-auto"
          >
            Atualizar Lista
          </Button>

          <Button
            variant="ghost"
            iconName="X"
            onClick={onClearFilters}
            className="w-full sm:w-auto sm:flex-shrink-0"
          >
            Limpar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContractFilters;
